export default {
  id: null,
  valor: null,
  dataInicial: null,
  dataFinal: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/kmvaluemodel.js